import React from "react";
import { Alert, Box, Stack } from "@mui/material";
import { LayerCard } from "./SpecsEditorImagePanels";
import { useSpecsEditorContextValue } from "./useSpecsEditor";
import SpecsLayerViewToggle from "./SpecsLayerViewToggle";
import SpecsStyleSelector from "./SpecsStyleSelector";
import { CompositePreviewSection } from "./SpecsCompositePreviewSection";

export default function SpecsDesignEditorPage() {
  const { effectiveLayerView, selectedElement, selectedLayer } =
    useSpecsEditorContextValue();

  if (!selectedLayer && !selectedElement) {
    return (
      <Alert severity="info">
        Select an element or layer to edit the design outputs.
      </Alert>
    );
  }

  let content: React.ReactNode;
  if (selectedLayer) {
    content = <LayerCard key={selectedLayer.id} layer={selectedLayer} />;
  } else if (effectiveLayerView === "global") {
    content = <CompositePreviewSection />;
  } else {
    content = (
      <Alert severity="info">
        This style does not have editable layer images.
      </Alert>
    );
  }

  return (
    <Box sx={{ pb: "100px" }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <SpecsStyleSelector />
        <SpecsLayerViewToggle />
      </Stack>
      {content}
    </Box>
  );
}
